
import { Button } from '@chr/eds-react';
import ErrorStateIcon from '../../assets/img/error_state.svg';
import { Box, Card, CardContent, Grid } from "@mui/material";
import "./WidgetErrorState.scss"
import { useTranslation } from "@chr/online-shared-ui-localizations";

export interface WidgetErrorStateProps {
    title: string
    retryCallback: () => void
}

export const WidgetErrorState = ({title, retryCallback}: WidgetErrorStateProps) => {
    const translate = useTranslation();
    const getIcon = () => {
        return (
          <div className="error-state-icon" data-testid="error-state-icon">
            <img
                src={ErrorStateIcon}
                alt=""
            />
          </div>
        )
    }

    const getErrorText = () => {
        return (
            <div>
                <div className="primary-text" data-testid="primary-text">
                    {translate('We could not retrieve this information')}
                </div>
                <div className="secondary-text" data-testid="secondary-text">
                    {translate('An error occurred while retrieving this information. you can try again by clicking the retry button')}
                </div>
                <div className='retry-button grid-layout-drag-cancel'>
                    <Button id='btnRetry' data-testid='retry-button' buttonText={translate('Retry')} variant="tertiary" type='button' onClick={retryCallback}></Button>
                </div>
            </div>
        );
    }

    return (
        <Grid item xs={12} sm={6} md={12}>
            <Card>
                <CardContent sx={{padding: 0}}>
                    <div className="widget-header">
                        <Box className="widget-title grid-layout-drag-handle" title={translate(title)}>
                            {translate(title)}
                        </Box>
                    </div>
                    <div className="widget-error-state-content">
                        {getIcon()}
                        {getErrorText()}
                    </div>
                </CardContent>
            </Card>
      </Grid>
    )
}

export default WidgetErrorState;